import IconDrakeInfernal from './IconDrakeInfernal';

export default IconDrakeInfernal;